import { useAtBreakpoint } from '@stitch-fix/mode-react';
import { CloudinaryVideoPlayerProps } from '../CloudinaryVideoPlayer';

export type VideoBreakpointProps = {
  mobileVideo: string;
  tabletVideo: string;
  desktopVideo: string;
  mobileVideoAspectRatio?: string;
  tabletVideoAspectRatio?: string;
  desktopVideoAspectRatio?: string;
} & Omit<CloudinaryVideoPlayerProps, 'videoUrl'>;

export const videoBreakpointDefault: VideoBreakpoints = {
  mobile: 1280,
  tablet: 768,
  desktop: 1280,
};

type VideoUrls = {
  mobile: string;
  tablet: string;
  desktop: string;
};

type VideoBreakpoints = {
  mobile: number;
  tablet: number;
  desktop: number;
};

type UrlFromBreakpointsConfig = {
  url: VideoUrls;
  breakpoint?: Partial<VideoBreakpoints>;
};

export const useUrlFromVideoBreakpoints = ({
  url,
  breakpoint: {
    tablet = videoBreakpointDefault.tablet,
    desktop = videoBreakpointDefault.desktop,
  } = videoBreakpointDefault,
}: UrlFromBreakpointsConfig): string => {
  const isDesktop = useAtBreakpoint(tablet);
  const isTablet = useAtBreakpoint(desktop);

  if (isDesktop) return url.desktop;
  if (isTablet) return url.tablet;

  return url.mobile;
};
